import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { LOADING_DATA, LOADED_DATA, ActionPayload, loadedItem, LOADING_ITEM, loadedResourceVisits, LOADING_RESOURCE_VISITS } from "./actions";
import { newsService, resourceTagsService, resourceVisitsService } from "../services";
import { authSelector } from "./selectors";
import { PagedResponse, QueryParams } from "@ofqual/portal-core/core/types";
import { News } from "../domain/News";
import { Activity } from "../domain/Activity";

function* watchNewsSaga() {
  yield takeLatest(LOADING_DATA, newsSaga);
}

function* watchItemSaga() {
  yield takeLatest(LOADING_ITEM, itemSaga);
}

function* watchGetResourceVisitsSaga() {
  yield takeLatest(LOADING_RESOURCE_VISITS, getResourceVisitsSaga);
}

function* newsSaga({ payload }: ActionPayload<QueryParams>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);

  const response: PagedResponse<News> = yield call(
    [newsService, newsService.search],
    { ...payload },
    { token: auth.token }
  );
  yield put({ type: LOADED_DATA, payload: response });
}

function* itemSaga({ payload }: ActionPayload<string>) {
  const { token } = yield select(authSelector);

  const { item, resourceTags } = yield all({
    item: call(
      [newsService, newsService.get],
      payload,
      {
        token,
      }
    ),
    resourceTags: call(
      [resourceTagsService, resourceTagsService.get],
      payload,
      {
        token,
      }
    ),
  });
  item.resourceTags = resourceTags;

  yield put(loadedItem(item));
}

function* getResourceVisitsSaga() {
  const { token } = yield select(authSelector);

  const resourceVisits: Activity[] = yield call(
    [resourceVisitsService, resourceVisitsService.get],
    { token }
  )

  yield put(
    loadedResourceVisits(resourceVisits)
  );
}

export function* rootSaga() {
  yield all([
    watchNewsSaga(),
    watchItemSaga(),
    watchGetResourceVisitsSaga(),
  ]);
}
